package xim.poc.game.configuration.v0.tactics

import xim.poc.ActorId
import xim.poc.game.configuration.constants.*
import xim.poc.game.configuration.v0.ItemDropDefinition
import xim.poc.game.configuration.v0.ItemRankSettings
import xim.poc.game.configuration.v0.interactions.BarterConfiguration
import xim.poc.game.configuration.v0.interactions.BarterInteractionUiState
import xim.poc.game.configuration.v0.interactions.BarterItem
import xim.poc.ui.ChatLog
import xim.poc.ui.ChatLogColor
import xim.poc.ui.ShiftJis


object TacticsItemShop {

    val unlockableItems = linkedMapOf(
        tacticsChallenge_Emissary to BarterItem(ItemDropDefinition(itemId = itemBoneEarring_13321, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf()),
        tacticsChallenge_Frontier to BarterItem(ItemDropDefinition(itemId = itemBeetleEarring_13323, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf()),
        tacticsChallenge_AncientVows to BarterItem(ItemDropDefinition(itemId = itemFangEarring_13325, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf()),
        tacticsChallenge_BattaruRoyale to BarterItem(ItemDropDefinition(itemId = itemCoralEarring_13312, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf()),
        tacticsChallenge_Nought to BarterItem(ItemDropDefinition(itemId = itemTortoiseEarring_13324, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf()),
        tacticsChallenge_Remnants to BarterItem(ItemDropDefinition(itemId = itemLadybugEarring_15996, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf()),
        tacticsChallenge_Disjoined to BarterItem(ItemDropDefinition(itemId = itemLadybugRing_15815, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf()),
    )

    private var describedSelf = false

    fun push(vendorId: ActorId) {
        if (!describedSelf) {
            describedSelf = true
            ChatLog("Defeat ${ShiftJis.colorKey}Challenges${ShiftJis.colorClear} to unlock more items!", ChatLogColor.Info)
        }

        val items = ArrayList<BarterItem>()
        items += BarterItem(ItemDropDefinition(itemId = itemShellEarring_13313, rankSettings = ItemRankSettings.fixed(1)), requiredItems = listOf())

        for ((itemId, barterDefinition) in unlockableItems) {
            if (!TacticsState.hasClearedChallenge(itemId)) { continue }
            items += barterDefinition
        }

        BarterInteractionUiState(vendorId, BarterConfiguration(items)).push()
    }

}